/**
 * 可注入种子的确定性伪随机源。**玩法随机一律走它，禁止 `Math.random`。**
 *
 * 理由不是洁癖：种子 + 输入流构成一次尝试的完整初始条件，回放校验（Backlog T029/T030）
 * 与「同一段输入对比两组参数」都依赖它。原型里散着 8 处 `Math.random`，照抄的话这些调用点
 * 会分布在每一项机制里，事后统一替换等于把机制重做一遍。
 *
 * 算法是 mulberry32：状态只有一个 32 位整数，无分配、无依赖，序列质量对玩法足够。
 * 它不是加密安全的，也不需要是。
 */
export class DeterministicRandom {
  private state = 0;

  constructor(seed: number) {
    this.reset(seed);
  }

  reset(seed: number): void {
    this.state = seed >>> 0;
  }

  /** 均匀分布于 `[0, 1)`。调用方按此假设做区间映射，实现不得越界。 */
  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let value = this.state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  }

  /** `[min, max)` 上的均匀实数。 */
  range(min: number, max: number): number {
    return min + this.next() * (max - min);
  }
}
